// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zNmVMoo82mgxdhmSa6wO7Q\\=\\={display:flex;gap:var(--xds-spacing-b);align-items:center}", "",{"version":3,"sources":["webpack://./src/shared/components/PIEButton/PIEButton.module.scss"],"names":[],"mappings":"AAIA,4BACI,YAAA,CACA,wBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button_icon": "zNmVMoo82mgxdhmSa6wO7Q=="
};
export default ___CSS_LOADER_EXPORT___;
